<template>
  <div :class="`tabs ${design}`">
    <div
      v-for="(sTab, iTab) in filteredTabs"
      :key="iTab"
      :class="{ active: sTab.name === tabActive }"
      @click="changeTab(sTab)"
    >
      <p class="tab-name">{{ sTab.name }}</p>
      <span v-if="sTab.count !== undefined" class="qty">{{ sTab.count }}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      realTabs: this.tabs,
      tabActive: this.tabs[0].name,
    };
  },
  props: {
    tabs: { type: Array, required: true },
    design: { type: String, default: null },
    tabActived: {},
  },
  methods: {
    changeTab(sTab) {
      this.tabActive = sTab.name;
      this.$emit("change", sTab.value);
    },
  },
  created() {
    if (typeof this.tabActived == "number") {
      this.tabActive = this.tabs[this.tabActived].name;
    }
  },
  watch: {
    // Atualizar contador
    tabActived: function (newVal) {
      if (typeof newVal == "number") {
        const selectedTab = this.tabs.find((tab, index) => index === newVal);
        this.tabActive = selectedTab.name;
      }
    },
    tabs: function (newVal, oldVal) {
      this.realTabs = newVal;
    },
  },
  computed: {
    filteredTabs() {
      return this.realTabs.filter(
        (item) => item.enabled || item.enabled === undefined
      );
    },
  },
};
</script>
<style scoped>
.tabs {
  display: flex;
  border-radius: 5px;
  margin-bottom: 20px;
  overflow: hidden;
  cursor: pointer;
}
.tabs > div {
  width: 100%;
  color: #999999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  font-size: 12px;
  line-height: 15px;
  border: 1px solid #515159;
  font-weight: bold;
}
.tabs > div:first-child {
  border-radius: 5px 0 0 5px;
}
.tabs > div:last-child {
  border-radius: 0 5px 5px 0;
}
.tabs > div.active {
  background-color: var(--box);
}
.tabs.two > div {
  justify-content: space-between;
}
.tabs.two > div.active {
  border: 1px solid #45454d;
  background-color: #45454d;
}
.tabs > div:not(:last-child) {
  border-right: none;
}
.drawer-content .tabs > div.active {
  background-color: var(--box-up);
  border: 1px solid var(--box-up);
}
.qty {
  background-color: #612640;
  border-radius: 14px;
  padding: 5px;
  min-width: 25px;
  min-height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
</style>